'use strict';

/**
 * Base class for an ItemView
 *
 * @category   Model
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var Html = require('base/Colido.Html');

var ItemView = Marionette.ItemView.extend({
    /**
     * Should the item be wrapped?
     * @var {boolean}
     */
    wrapItem: true,

    isActive: false,

    /**
     * Additional data for view
     * @type {object}
     */
    viewData: {},

    /**
     * Defines sizes for the responsive images
     * @type {object}
     */
    imageSizes: {
        table: '100x100',
        thumbnail: '50x50',
        thumbnailFixed: '50x50c',

        default: '640x640',
        defaultFixed: '640x640c',
        medium: '512x512',
        mediumFixed: '512x512c',
        listPreview: '400x400',
        smedium: '400x400',
        small: '128x128',

        // Object image in grid view
        'grid-object': [
            '400x400',
            '256x256',
        ],

        'slideshow-object': '800x800',

        // Set image in grid view
        'grid-set': '400x400',

        detail: [
            '1600x1200',
            '1000x750',
            '800x600',
            '600x450',
            '400x300',
        ],

        'detail-zoom': [
            '2560x1920',
            '2000x1500',
            '1600x1200',
            '1200x900',
            '800x600',
            '400x300',
        ],

        'detail-preview-thumb': '75x60c',
    },

    /**
     * Defines the related viewport size for the responsive images.
     * The key should be equal to the imageSizes object
     * @type {object}
     */
    imageViewportSizes: {
        'grid-object': '22rem',
        'detail': '50vw',
        'detail-zoom': '100vw',
    },

    constructor: function() {
        Marionette.ItemView.prototype.constructor.apply(this, arguments);

        this.listenTo(App.vent, 'resizeThrottled', function() { this.triggerMethod('resize'); }.bind(this));
    },

    initialize: function(options) {
        if (options) {
            _.extend(this.viewData, options.viewData);
        }

        this.isActive = this.getOption('isActive');
    },

    /**
     * Definition of additional data, that is assigned to view
     * @returns {Object} The data, that is assigned to view
     */
    serializeData: function() {
        var data = {
            item: Marionette.ItemView.prototype.serializeData.apply(this, arguments),
        };

        // Extend with model extra view vars
        if (this.viewData) {
            _.each(this.viewData, function(value, key) {
                data.item[key] = _.isFunction(value) ? value.bind(this)() : value;
            }.bind(this));
        }

        return data;
    },

    /**
     * Overrides the render function
     * @return {void}
     */
    onRender: function () {
        if (!this.wrapItem) {
            this.$el = this.$el.children();
            this.$el.unwrap();
            this.setElement(this.$el);
        }
    },
});

module.exports = ItemView;